import type { SearchParameters } from 'ofetch'
import type { UseFetchOptions } from 'nuxt/app'
import type { KftApiDefaultResponse } from '~/composables/types/kft-api'
interface UseKftApiPaginatedFetchOptions<T> {
  paginated?: boolean
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' // get this type from ofetch
  query?: SearchParameters
  fetchOptions?: UseFetchOptions<T>
}

export const useKftApiPaginatedFetch = async <T>(
  path: string,
  options: UseKftApiPaginatedFetchOptions<T> = {
    paginated: true,
    method: 'GET',
  }
) => {
  const {
    currentPage,
    objectsPerPage,
    totalPages,
    totalObjects,
    currentPageCount,
    goToNextPage,
    goToPrevPage,
    goToPage,
  } = useKftApiPagination()

  const query = {
    ...options.fetchOptions?.query,
    ...options?.query,
    page: currentPage,
    limit: objectsPerPage,
  }

  const fetchOptions: UseFetchOptions<T> = {
    method: options?.method || 'GET',
    ...options.fetchOptions,
    query,
  }

  const { data, error, pending, status, refresh, execute } =
    await useKftApiFetch<KftApiDefaultResponse<T>>(path, fetchOptions)

  watchEffect(() => {
    if (!data.value || !data.value.meta) return
    totalObjects.value = data.value.meta.pagination.total
    currentPageCount.value = data.value.meta.pagination.count
    totalPages.value = data.value.meta.pagination.total_pages
  })

  return {
    data,
    error,
    pending,
    status,
    refresh,
    execute,
    pagination: readonly({
      currentPage,
      objectsPerPage,
      totalPages,
      totalObjects,
      currentPageCount,
      goToNextPage,
      goToPrevPage,
      goToPage,
    }),
  }
}
